import { createFileRoute } from "@tanstack/react-router";
import { Calls } from "../../../components/calls/callsTable";

export const Route = createFileRoute("/_app/calls/")({
  component: Calls
});
